import React from 'react';
import {NavLink} from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import AcUnitIcon from '@material-ui/icons/AcUnit';

const Navbar = () => {
    return (
        <>
        <div className="container-fluid nav_bg">
        <div className="row">
            <div className="col-10 mx-auto">

        

<nav className="navbar navbar-expand-lg navbar-light bg-light">
  <div className="container-fluid">
  
 
 <NavLink className="navbar-brand" to='/'> <AcUnitIcon /> ELEVATION</NavLink>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarSupportedContent">
      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
        <li className="nav-item">
        
       
          <NavLink exact activeClassName="menu-active" className="nav-link" aria-current="page" to="/" >Home</NavLink>
        </li>
        <li  className="nav-item">
          <NavLink  activeClassName="menu-active" className="nav-link" to="/portfolio" >Portfolio</NavLink>
        </li>
        <li className="nav-item">
          <NavLink  activeClassName="menu-active" className="nav-link" to="/stories" >Stories</NavLink>
        </li>
        <li className="nav-item">
          <NavLink  activeClassName="menu-active" className="nav-link" to="/team" >Team</NavLink>
        </li>
        <li className="nav-item">
          <NavLink  activeClassName="menu-active" className="nav-link" to="/career" >Careers</NavLink>
        </li>
      </ul>
    </div>
    
    
  </div>
  <NavLink className="btn btn-dark" to="/launch" role="button"> LAUNCH</NavLink>
  </nav>
  </div>
 </div>

  </div>
    </>
    );
}
export default Navbar;